import {
	isConversationChannelDataMessage,
	isSSEMessage,
	isStreamAgenticUi,
	isStreamHeartbeat,
	isStreamMemoryUpdate,
	type ParsedSSEMessage,
	type StreamMessage,
} from '@atlassian/conversation-assistant-service-api/types/assistance-service';

/** Only known post-final guard and enrichment events may retain an earlier answer. */
export const invalidatesProcessedFinalResponse = (
	event: StreamMessage | ParsedSSEMessage<StreamMessage>,
	processedMessageId?: string,
): boolean => {
	const message = isSSEMessage(event) ? event.data : event;
	if (isStreamHeartbeat(message) || isStreamAgenticUi(event) || isStreamMemoryUpdate(message)) {
		return false;
	}
	if (isConversationChannelDataMessage(message)) {
		return !processedMessageId || message.assistant_message_id !== processedMessageId;
	}
	switch (message.type) {
		case 'RESPONSE_REDACTION':
		case 'RESPONSE_BLOCKED':
		case 'ATTACHMENT_BLOCKED':
		case 'FOLLOW_UP_QUERIES':
		case 'ENTITY_ANNOTATIONS':
		case 'RECONNECT_SUPPORTED':
		case 'SPACE_SOURCE_RECOMMENDATIONS':
		case 'CONVERSATION_TITLE_UPDATED':
		case 'TASK_STATUS':
		case 'INTERACTION_CONCLUSION':
			return false;
		default:
			// Includes reasoning/research, another final response, and future event types.
			return true;
	}
};
